import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules';
import store from '@/app/store';
import * as auth0 from 'auth0-js';
import AUTH_CONFIG from '../config';
import { Authentication } from '../types';
import Router from '@/router';

// tasks
import loginTask from '../tasks/login.task';

const webAuth = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    redirectUri: `${window.location.origin}/callback`,
    clientID: AUTH_CONFIG.clientId,
    responseType: 'id_token',
    scope: 'openid profile email',
});

@Module
class AuthModule extends VuexModule {
    private authentication: Authentication | null = null;
    private authenticated = false;

    get item() {
        return this.authentication;
    }

    get auth() {
        return webAuth;
    }

    get isAuthenticated() {
        return this.authenticated;
    }

    @Action
    public logIn(path: string) {
        // console.debug('login current path', path);
        authModule.auth.authorize({
            state: path,
        });
    }
    @Action
    public handleAuthentication() {
        webAuth.parseHash((error: any, response: any) => {
            if (error) {
                this.logOut();
                return;
            }

            this.setToken(response);
            Router.push(response.state);
        });
    }
    @Action
    public renewToken() {
        webAuth.checkSession({}, (error: any, response: any) => {
            if (error) {
                this.logOut();
                return;
            }

            this.setToken(response);
        });
    }
    @Action
    public logOut() {
        this.unsetToken();
        webAuth.logout({
            returnTo: window.location.origin,
        });
    }

    @Mutation
    private setToken(response: any) {
        // console.log('setToken response', response);
        this.authentication = {
            idToken: response.idToken,
            profile: response.idTokenPayload,
            tokenExpiry: new Date(response.idTokenPayload.exp * 1000),
        };

        this.authenticated = true;
    }
    @Mutation
    private unsetToken() {
        this.authentication = null;
        this.authenticated = false;
    }
}

export const authModule = new AuthModule({ store, name: 'authModule' });
